import DepositInput from "./DepositInput";

export default DepositInput;